import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";
import LinearProgress from "@material-ui/core/LinearProgress";


const styles = theme => ({
    qualityRecord: {},
    dualProgress: {
        display: "flex",
        justifyContent: "space-around",
        flexFlow: "row wrap",
        alignItems: "stretch",
    },
    linearProgress: {
        width: "50%",
    }
});

const normalise = (value, min, max) => {
    return (value - min) * 100 / (max - min)
};

const InvertLinearProgress = withStyles({
    colorPrimary: {
        backgroundColor: '#2196f3',
    },
    barColorPrimary: {
        backgroundColor: 'rgb(193, 225, 251)',
    },
    colorSecondary: {
        backgroundColor: '#f50057',
    },
    barColorSecondary: {
        backgroundColor: 'rgb(255, 140, 179)',
    },
})(LinearProgress);

@withStyles(styles)
class QualityRecord extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
        record: PropTypes.object.isRequired
    };

    state = {};

    render() {
        const {classes, record} = this.props;

        return (
            <React.Fragment>
                {record.min_treshold >= 0 ?

                    (
                        <div className={classes.qualityRecord}
                             key={record.name}>

                            <Typography variant="body1">
                                {record.name} : {record.value}</Typography>

                            <LinearProgress
                                value={record.value}
                                variant="determinate"
                            />
                        </div>
                    )
                    :
                    ( record.value < 0 ?
                        (
                          <div className={classes.qualityRecord}
                             key={record.name}>

                            <Typography variant="body1">
                                {record.name} : {record.value}</Typography>

                            <div className={classes.dualProgress}>
                                <InvertLinearProgress
                                    color="secondary"
                                    value={normalise(record.value+record.max_treshold, record.min_treshold, record.max_treshold)}
                                    variant="determinate"
                                    className={classes.linearProgress}
                                />
                                <LinearProgress
                                    value={0}
                                    variant="determinate"
                                    className={classes.linearProgress}
                                />
                            </div>
                        </div>
                        )
                        :(
                            <div className={classes.qualityRecord}
                             key={record.name}>

                            <Typography variant="body1">
                                {record.name} : {record.value}</Typography>

                            <div className={classes.dualProgress}>
                                <InvertLinearProgress
                                    color="secondary"
                                    value={100}
                                    variant="determinate"
                                    className={classes.linearProgress}
                                />
                                <LinearProgress
                                    value={normalise(record.value, record.min_treshold, record.max_treshold)}
                                    variant="determinate"
                                    className={classes.linearProgress}
                                />
                            </div>
                        </div>
                        )

                    )}
            </React.Fragment>
        );
    }
}

export default QualityRecord;